import * as React from 'react';
import cx from 'classnames';

// Hooks
import useResponsiveLayout from './hooks/useResponsiveLayout';

// Constants
import { Layout } from './constants';

import { ResponsiveContainerProps } from './types';

import styles from './style.scss';

export { Layout, useResponsiveLayout };
export type { ResponsiveContainerProps };

export function ResponsiveContainer({
  className,
  children,
}: ResponsiveContainerProps): JSX.Element {
  return <div className={cx(className, styles.container)}>{children}</div>;
}
